
import Advert from '../Advert';
import Content, * as ContentConstants from '../Content';
import { colorConversionToCss } from '../CMS';

import Media from './Media';

import baseConfiguration from '../../helpers/Fmt-player-Configuration/base.configuration';    // REVIEW mover de helpers/ a templates/

const processAdvertisement = ( adserver, advert) => {
  if( adserver || advert) {
    const adTagUrl = adserver || `data:text/xml,${Advert.generateVMAP( advert)}`;
    return {
      id: 'flumotion-player',
      startAt: null,
      adTagUrl,
    };
  } else return null;
};

const processContent = ( playerBaseConfiguration, loadedConfiguration) => {
  const { singleMedia, playlist, mainWithBackups, balancedFallbacks, multiChannel, contentType } = Content.processConfiguration( loadedConfiguration, Media.processMedia);
  let playerSiteData, firstContent, auxiliarData;
  const updateAuxiliarDataFromProcessedMedia = media => {
    return {
      posterUrl: media.poster,
      mediaSrcType: media.srcType,
      chaptersUrl: media.chapters,
      captions: media.captions,
    };
  };
  switch( contentType) {
    case ContentConstants.ContentTypes.SingleMedia:
      playerSiteData = { ...playerBaseConfiguration, ...singleMedia };
      auxiliarData = updateAuxiliarDataFromProcessedMedia( singleMedia);
      break;
    case ContentConstants.ContentTypes.Playlist:
      playerSiteData = {
        items: playlist.map( content => {
          return { ...playerBaseConfiguration, ...content };
        }),
      };
      auxiliarData = updateAuxiliarDataFromProcessedMedia( playlist[0]);    // REVIEW
      break;
    case ContentConstants.ContentTypes.MainWithBackups:
      firstContent = mainWithBackups.contents[ mainWithBackups.current];
      playerSiteData = { ...playerBaseConfiguration, ...firstContent };
      auxiliarData = updateAuxiliarDataFromProcessedMedia( firstContent);
      break;
    case ContentConstants.ContentTypes.BalancedFallbacks:
      firstContent = balancedFallbacks.contents[ balancedFallbacks.current];
      playerSiteData = { ...playerBaseConfiguration, ...firstContent };
      auxiliarData = updateAuxiliarDataFromProcessedMedia( firstContent);
      break;
    case ContentConstants.ContentTypes.MultiChannel:
      firstContent = multiChannel.contents[ multiChannel.current];
      playerSiteData = { ...playerBaseConfiguration, ...firstContent };
      auxiliarData = updateAuxiliarDataFromProcessedMedia( firstContent);
      break;
    default:;
  }
  const contentData = {
    contentType,
    mainWithBackups,
    balancedFallbacks,
    multiChannel,
  };
  if( loadedConfiguration.errorMedia) contentData.errorMedia = Media.processMedia( loadedConfiguration, loadedConfiguration.errorMedia);
  return { playerSiteData, contentData, auxiliarData };
};

const Fmt_player_Configuration = {

  processConfiguration: (loadedConfiguration = {}) => {

    // REVIEW generar internamente la configuracion base? o usar diferentes variantes, como plantillas, dependiendo del caso
    const fmt_playerConfiguration = baseConfiguration;
    const playerBaseConfiguration = fmt_playerConfiguration.playerSiteData;
  
    playerBaseConfiguration.autoplay = (loadedConfiguration.autoplay && true) || false;
    playerBaseConfiguration.download = (loadedConfiguration.download && true) || false;   // TOFIX parece que esto en true no funciona, investigar, puede ser que cuando no es false require un valor (ejemplo: url)
    playerBaseConfiguration.title = loadedConfiguration.name;
    // playerBaseConfiguration.skin.primaryColor = colorConversionToCss({ a: 1, r: 255, g: 0, b: 0 });      // TESTING
    // playerBaseConfiguration.skin.secondaryColor = colorConversionToCss({ a: 1, r: 0, g: 255, b: 0 });    // TESTING
    // playerBaseConfiguration.skin.backgroundColor = colorConversionToCss({ a: 1, r: 0, g: 0, b: 255 });   // TESTING
    playerBaseConfiguration.skin.backgroundColor = colorConversionToCss( loadedConfiguration.design && loadedConfiguration.design.colorBar);
    playerBaseConfiguration.advertisement = processAdvertisement( loadedConfiguration.adserver, loadedConfiguration.advert);
  
    // TODO compartir, ver opciones que acepta el parametro share, 
    // TODO TOFIX REVIEW download y processContent.playerSiteData.downloadableSrc de processContent y multiples content

    const { playerSiteData, contentData, auxiliarData } = processContent( playerBaseConfiguration, loadedConfiguration);
    fmt_playerConfiguration.playerSiteData = playerSiteData;
  
    return { fmt_playerConfiguration, contentData, auxiliarData };
  },

};

export default Fmt_player_Configuration;
